export default "__VITE_ASSET__B$gT$xhw__"